import { useMemo } from "react";
import { useColor } from "../../../../components/ui/ColorContext"; // adjust path if needed

interface Particle {
  id: number;
  left: number;
  size: number;
  duration: number;
  delay: number;
  opacity: number;
}

export const ParticleField = () => {
  const { primaryColor } = useColor();

  const particles = useMemo<Particle[]>(() => {
    return Array.from({ length: 20 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      size: 2 + Math.random() * 3,
      duration: 8 + Math.random() * 6,
      delay: Math.random() * 5,
      opacity: 0.2 + Math.random() * 0.3,
    }));
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-[2]">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="absolute rounded-full particle-float"
          style={{
            left: `${particle.left}%`,
            bottom: "-20px",
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            opacity: particle.opacity,

            // dynamic primary color
            background: primaryColor,

            animationDuration: `${particle.duration}s`,
            animationDelay: `${particle.delay}s`,

            // glow effect using dynamic color
            boxShadow: `
              0 0 ${particle.size * 2}px ${primaryColor}80,
              0 0 ${particle.size * 4}px ${primaryColor}40
            `,
          }}
        />
      ))}
    </div>
  );
};